import { StyledButton } from './index.styles'

export default StyledButton
